import { Link } from "react-router-dom"

export default function ChoisireTemplate(props){
    
    return(
        <div className="container-fluid overcover">
            <div className="container profile-box row">
                
                <div className="col-sm-12" style={{textAlign:"center"}}> 
                        <p style={{fontSize: "16px", fontWeight: "bold", color:"black"}}>
                               CHOISIR LE MODÈLE DES CV  
                        </p>
                </div>
                <div className="col-sm-12" style={{display:"flex", justifyContent: "center"}}>
                    <div className="row">
                        <div className="col-6" style={{textAlign: "center"}}>
                            <Link to='#' onClick={() => {props.changerTemplate(0)}}>
                                <img src={`${process.env.PUBLIC_URL}/images/CV2.webp`} alt="template 1" style={{height: "200px",  width: "auto", marginRight:"10px"}}/>
                            </Link>
                        </div>
                        <div className="col-6" style={{textAlign: "center"}}>
                            <Link to='#' onClick={() => {props.changerTemplate(1)}}>
                                <img src={`${process.env.PUBLIC_URL}/images/CV1.jpeg`} alt="template 2" style={{height: "200px",  width: "auto", marginRight:"10px"}}/>
                            </Link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}